import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
// material-ui
import withStyles from "@material-ui/styles/withStyles";
// config
import { COPYRIGHT } from "config";
import PropTypes from "prop-types";
import React from "react";
// styles
import styles from "./styles";

class Copyright extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <Hidden smDown>
          <Typography
            display="block"
            variant="caption"
            className={classes.white}
          >
            {COPYRIGHT}
          </Typography>
        </Hidden>
      </div>
    );
  }
}

export default withStyles(styles)(Copyright);
